import React from "react"
import { Button, Card } from "react-bootstrap"
import { Player } from "video-react"

const CandidateData = ({ candidateData }) => {
  // Assume candidateData is an object containing detailed information about the candidate

  const downloadFile = () => {
    // Use appropriate logic to trigger the file download
    // For example, you can create an anchor element and simulate a click
    const link = document.createElement('a');
    link.href = candidateData.fileURL;
    link.download = candidateData.name + candidateData.surname; // You can set a custom filename here
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  return (
    <Card className="mb-2">
      <Card.Body>
        {candidateData.type == "video" ?
          <Player
            playsInline
            src={candidateData.fileURL}
          />
          :
          <Button onClick={downloadFile}>Pobierz plik</Button>
        }
        <hr />
        <Card.Title>
          {candidateData.name}&nbsp;{candidateData.surname}
          {candidateData.scholarshipType ? (
            <span className="candidate-scholarship-type">
              {" "}
              {candidateData.scholarshipType.includes("Bronisławy Skup")
                ? "Stypendium imienia Bronisławy Skup"
                : candidateData.scholarshipType}
            </span>
          ) : null}
        </Card.Title>

        <div className="row">
          {/* Left Column - Personal Data */}
          <div className="col-md-4">
            <Card.Text>
              <strong>Data urodzenia:</strong> {candidateData.birthdate}
            </Card.Text>
            <Card.Text>
              <strong>Adres Email:</strong> {candidateData.emailAdress}
            </Card.Text>
            <Card.Text>
              <strong>Polityka prywatności:</strong> {candidateData.agreement2 === true ? "Zgoda" : "Brak zgody"}
            </Card.Text>

          </div>

          {/* Middle Column - Address */}
          <div className="col-md-4">
            <Card.Text>
              <strong>Miasto:</strong> {candidateData.cityName}
            </Card.Text>



            <Card.Text>
              <strong>Kod pocztowy:</strong> {candidateData.postalCode}
            </Card.Text>
            <Card.Text>
              <strong>Adres:</strong> {candidateData.streetName}&nbsp;{candidateData.houseNumber} &nbsp;{candidateData.localNumber}
            </Card.Text>
          </div>

          {/* Right Column - Guardian Data */}
          <div className="col-md-4">
            <Card.Text>
              <strong>Imię opiekuna:</strong> {candidateData.guardianName}&nbsp;{candidateData.guardianSurname}
            </Card.Text>

            <Card.Text>
              <strong>Numer opiekuna:</strong> {candidateData.guardianNumber}
            </Card.Text>
            <Card.Text>
              <strong>Email opiekuna:</strong> {candidateData?.guardianEmail}
            </Card.Text>
          </div>
        </div>

        {/* Additional rows or modifications can be made as needed */}
      </Card.Body>
    </Card>
  )
}

export default CandidateData
